import {excess} from '@fl/cmsch-fe-library';
import * as t from 'io-ts';

export const ValidateContactErrorsSchema = excess(t.partial({
    value: t.string,
    contactType: t.string,
}));

